angular.module("vgresiduos").directive("destinationFollowupAccordion", function () {
	return {
		scope: true,
		controller: "DestinationFollowupAccordionCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/followup/followupAccordion/destinationFollowupAccordion_template.html",
		bindToController: {
			newOptions: "="
		}
	};
});
